import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="container-main py-3 flex items-center gap-1.5 text-sm text-gray-500 overflow-x-auto">
      <Link to="/" className="hover:text-black transition-colors shrink-0 flex items-center gap-1">
        <Home size={13} /> Home
      </Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5 shrink-0">
          <ChevronRight size={13} />
          {i === items.length - 1 ? (
            <span className="font-semibold text-black">{item.name}</span>
          ) : (
            <Link to={item.path} className="hover:text-black transition-colors">{item.name}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
